import React from 'react';

import { Block, JsonLD, withConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Clickable, ClickableButton } from '../common/Button.jsx';
import { Column, Container, Row, Spaced } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { DropDown } from '../common/DropDown.jsx';
import { default as Image, ImageSrcSet } from '../common/Image.jsx';
import { Component as InquirePopup } from './InquirePopup.jsx';
import { default as InventoryHelper, Subtitle } from '../common/Inventory.jsx';
import * as InventoryListCell from './InventoryListCell.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import { ContentContainer as _ContentContainer, withPaging } from '../common/List.jsx';
import { Footer, View as LoadingView } from '../common/Loading.jsx';
import LocalStorage from '../common/LocalStorage.jsx';
import Name from '../common/Name.jsx';
import { Component as OfferPopup } from './OfferPopup.jsx';
import PageType from '../common/PageType.jsx';
import { InventoryModal } from '../common/Popup.jsx';
import { Component as PurchasePopup } from './PurchasePopup.jsx';
import ScreenSize from '../common/ScreenSize.jsx';
import { SlideshowDot, withSlideshowConfiguration, withSlideshowInitialization } from '../common/Slideshow.jsx';
import { LayoutTabs, LayoutTabSelectionDropDown, TabV2, withLayoutTabOptions } from '../common/Tab.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

const sizeBuckets = {
  small: {
    min: 0,
    max: 12
  },
  medium: {
    min: 12,
    max: 30
  },
  large: {
    min: 30,
    max: 999999
  },
};

const defaultColumnCount = 4;

const hasInventoryListFilter = (requestData, context) => {
  for (let key of Object.keys(requestData)) {
    if (requestData[key] == undefined) {
      continue;
    }
    switch (key) {
      case 'artistState':
      case 'color':
      case 'maxPrice':
      case 'minPrice':
      case 'q':
        return true;
      case 'status':
        if (requestData[key] != context[key]) {
          return true;
        }
        break;
      default:
        if (key.startsWith('maxHeight') || key.startsWith('maxWidth') || key.startsWith('medium') || key.startsWith('minHeight') || key.startsWith('minWidth')) {
          return true;
        }
        break;
    }
  }
  return false;
}

// region INVENTORY LIST V1 (-- DEPRECATED Use `InventoryListV2` --)

class _InventoryListV1Component extends React.Component {
  constructor(props) {
    super(props);

    let showPrice;
    if (props.blockConfig) {
      showPrice = props.blockConfig.showPrice;

      if (showPrice == undefined) {
        if (props.blockConfig.block && props.blockConfig.block.hasThumbnailsLayout && props.blockConfig.grid && props.blockConfig.grid.cell && props.blockConfig.grid.cell.desktop && props.blockConfig.grid.cell.desktop.blocks) {
          showPrice = this._priceTokenPresent(props.blockConfig.grid.cell.desktop.blocks);
        }
        if (!showPrice && props.blockConfig.block && props.blockConfig.block.hasPinterestLayout && props.blockConfig.waterfall && props.blockConfig.waterfall.cell && props.blockConfig.waterfall.cell.desktop && props.blockConfig.waterfall.cell.desktop.blocks) {
          showPrice = this._priceTokenPresent(props.blockConfig.waterfall.cell.desktop.blocks);
        }
        if (!showPrice && props.blockConfig.block && props.blockConfig.block.hasSlideshowLayout && props.blockConfig.slideshow && props.blockConfig.slideshow.cell && props.blockConfig.slideshow.cell.desktop && props.blockConfig.slideshow.cell.desktop.blocks) {
          showPrice = this._priceTokenPresent(props.blockConfig.slideshow.cell.desktop.blocks);
        }
      }
    }
    this.state = {
      hasFilter: this._hasFilter(props),
      isArtist: props.config.userType == 1,
      showPrice
    };

    this._generateTabs = this._generateTabs.bind(this);
    this._getFilterConfig = this._getFilterConfig.bind(this);
    this._hasFilter = this._hasFilter.bind(this);

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleInventoryModalClose = this.handleInventoryModalClose.bind(this);
    this.handleInventoryModalOpen = this.handleInventoryModalOpen.bind(this);
    this.handleInquireModalClose = this.handleInquireModalClose.bind(this);
    this.handleInquireModalOpen = this.handleInquireModalOpen.bind(this);
    this.handleOfferModalClose = this.handleOfferModalClose.bind(this);
    this.handleOfferModalOpen = this.handleOfferModalOpen.bind(this);
    this.handlePurchaseModalClose = this.handlePurchaseModalClose.bind(this);
    this.handlePurchaseModalOpen = this.handlePurchaseModalOpen.bind(this);
    this.handleRequestData = this.handleRequestData.bind(this);
    this.handleResponseDataPostProcess = this.handleResponseDataPostProcess.bind(this);
    this.handleResponseDataPreProcess = this.handleResponseDataPreProcess.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  componentDidMount() {
    this.props.onRegisterRequestDataHandler(this.handleRequestData);
    this.props.onRegisterResponseDataPostProcessHandler(this.handleResponseDataPostProcess);
    this.props.onRegisterResponseDataPreProcessHandler(this.handleResponseDataPreProcess);

    const initialize = () => {
      if (!this.props.data) {
        this.props.onLoad();
      }
    };
    let filter;
    if (this.state.hasFilter) {
      const filterConfig = this._getFilterConfig(this.props) || {};
      const storedValues = LocalStorage.get(LocalStorage.keys.inventory);
      if (storedValues) {
        if (!filterConfig.hasQ) {
          storedValues.q = undefined;
        }
        if (!filterConfig.hasColor) {
          storedValues.color = undefined;
        }
        if (!filterConfig.hasMedium) {
          storedValues.medium = undefined;
        } else if (storedValues.medium) {
          const mediumList = filterConfig.mediumList || Defaults.Block[Name.Block.Inventory.ListV3].MediumList;
          const medium = [];
          storedValues.medium.forEach((d) => {
            // Check to see if the cached medium still exists in the list
            for (let i = 0; i < mediumList.length; i++) {
              if (mediumList[i].value != d) {
                continue;
              }
              medium.push(d);
              break;
            }
          });
          storedValues.medium = medium.length > 0 ? medium : undefined;
        }
        if (!filterConfig.hasPrice) {
          storedValues.maxPrice = undefined;
          storedValues.minPrice = undefined;
        }
        if (!filterConfig.hasDimensions) {
          storedValues.maxHeight = undefined;
          storedValues.minHeight = undefined;
          storedValues.maxWidth = undefined;
          storedValues.minWidth = undefined;
        }
        if (!filterConfig.hasSort) {
          storedValues.dir = undefined;
          storedValues.order = undefined;
        }
        if (!filterConfig.hasStatus) {
          storedValues.status = undefined;
        }
        if (!filterConfig.hasArtistState) {
          storedValues.artistState = undefined;
        }
        LocalStorage.put(LocalStorage.keys.inventory, storedValues);

        let temp;
        for (let id in storedValues) {
          temp = storedValues[id];
          if (temp == undefined) {
            continue;
          }
          if (!filter) {
            filter = {};
          }
          filter[id] = temp;
        }
        this.setState({
          filter
        }, initialize);
        return;
      }
    } else {
      // Ensure there are no cached filters (in case config changed since last visit)
      LocalStorage.remove(LocalStorage.keys.inventory);
    }
    initialize();

    let hash;
    if (location && location.hash) {
      hash = location.hash.replace('#', '');
      this._generateTabs(hash);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.screenSize != this.state.screenSize) {
      this.setState({
        screenSize: this.props.screenSize
      });
    }
    if (!this.props.builder || !prevProps.blockConfig || !this.props.blockConfig || !prevProps.context || !this.props.context) {
      return;
    }
    const prevBlockConfig = this.props.onNormalizeBlockConfig(prevProps);
    const blockConfig = this.props.onNormalizeBlockConfig(this.props);
    if (prevBlockConfig.order != blockConfig.order ||
      prevBlockConfig.type != blockConfig.type ||
      prevProps.context.order != blockConfig.order || // Extra check for new builder context
      prevProps.context.type != blockConfig.type ||   // Extra check for new builder context
      (this.props.context.subType != undefined && (prevProps.context.subType != blockConfig.subType || prevBlockConfig.subType != blockConfig.subType)) ||   // Extra check for new builder context
      prevProps.context.listId != this.props.context.listId ||
      prevProps.context.maxLimit != blockConfig.maxLimit ||
      prevProps.context.source != this.props.context.source ||
      prevProps.context.status != this.props.context.status ||
      prevProps.context.tags != this.props.context.tags) {
      this.props.onReset();
      this.props.onLoad();
    }
  }

  _generateTabs(hash) {
    const tabs = this.props.tabs.map((d) => {
      let path;
      const tab = { ...d };
      switch (tab.id) {
        case Layout.Type.Result.HorizontalMasonry:
          path = 'horizontal';
          break;
        case Layout.Type.Result.Pinterest:
          path = 'waterfall';
          break;
        case Layout.Type.Result.Slideshow:
          path = 'slideshow';
          break;
        case Layout.Type.Result.Thumbnails:
          path = 'grid';
          break;
      }
      if (this.props.blockConfig[path]) {
        if (this.props.blockConfig[path].display && this.props.blockConfig[path].display.length > 0) {
          tab.display = this.props.blockConfig[path].display;
        }
        if (this.props.blockConfig[path].anchorName && this.props.blockConfig[path].anchorName.length > 0) {
          tab.anchorName = this.props.blockConfig[path].anchorName;
        } else {
          tab.anchorName = tab.display.replace(' ', '').toLowerCase();
        }
        if (hash && tab.anchorName == hash) {
          this.handleTabClick(tab);
        }
      }
      return tab;
    });
    return tabs;
  }

  _getFilterConfig(props) {
    let blockConfig = props.blockConfig || {};
    if (blockConfig.filter) {
      return blockConfig.filter;
    } else if (blockConfig.block && blockConfig.block.extended && blockConfig.block.extended.search) {
      return blockConfig.block.extended.search;
    }
    return undefined;
  }

  _hasFilter(props) {
    const filterConfig = this._getFilterConfig(props);
    if (filterConfig) {
      for (let id in filterConfig) {
        switch (id) {
          case 'hasArtistState':
          case 'hasColor':
          case 'hasDimensions':
          case 'hasMedium':
          case 'hasPrice':
          case 'hasQ':
          case 'hasSort':
          case 'hasStatus':
            if (filterConfig[id]) {
              return true;
            }
            break;
          default:
            continue;
        }
      }
    }
    return false;
  }

  _priceTokenPresent(blocks) {
    let block;
    let priceTokenPresent = false;
    for (let i = 0; i < blocks.length; i++) {
      block = blocks[i];
      if (!block || !block.type || block.type.value != Name.Block.Inventory.Cell.Text) {
        continue;
      }
      if (block.config && block.config.block && block.config.block.design) {
        priceTokenPresent = block.config.block.design.indexOf(`token="PRICE"`) >= 0;
      }
      break;
    }
    return priceTokenPresent;
  }

  handleFilterChange(filter) {
    this.props.onReset();
    this.setState({
      filter
    }, () => {
      LocalStorage.put(LocalStorage.keys.inventory, filter);
      this.props.onLoad();
    });
  }

  handleInventoryModalClose() {
    this.setState({
      inventoryModal: undefined
    });
  }

  handleInventoryModalOpen(event) {
    if (!event || !event.currentTarget) {
      return;
    }
    event.preventDefault();

    this.setState({
      inventoryModal: {
        inventoryId: parseInt(event.currentTarget.id, 10),
        visible: true
      }
    });
  }

  handleInquireModalClose() {
    this.setState({
      inquireModal: undefined
    });
  }

  handleInquireModalOpen(inventory) {
    this.setState({
      inquireModal: {
        inventory: inventory,
        visible: true
      }
    });
  }

  handleOfferModalClose() {
    this.setState({
      offerModal: undefined
    });
  }

  handleOfferModalOpen(inventory) {
    this.setState({
      offerModal: {
        inventory: inventory,
        visible: true
      }
    });
  }

  handlePurchaseModalClose() {
    this.setState({
      purchaseModal: undefined
    });
  }

  handlePurchaseModalOpen(inventory) {
    this.setState({
      purchaseModal: {
        inventory: inventory,
        visible: true
      }
    });
  }

  handleRequestData(requestData) {
    const blockConfig = this.props.onNormalizeBlockConfig(this.props);
    requestData.artistId = this.props.context.artistId;
    requestData.inventoryId = this.props.context.inventoryId;
    requestData.maxLimit = blockConfig.maxLimit;
    requestData.status = this.props.context.status;
    requestData.subType = this.props.context.subType;
    requestData.tags = undefined;
    requestData.type = blockConfig.type;

    if (this.props.context.source == 3 || requestData.status == 3 || this.props.pageType == PageType.ExhibitionDetail || this.props.pageType == PageType.Content.ExhibitionTab) {
      requestData.listId = this.props.context.listId;
    } else {
      requestData.listId = undefined;
    }
    if (this.props.context.source == 6 || requestData.status == 6) {
      requestData.tags = this.props.context.tags;
    } else {
      requestData.tags = undefined;
    }
    if (!requestData.listId) {
      switch (blockConfig.order) {
        case '3a':
          requestData.dir = '0';
          requestData.order = '3';
          break;
        case '3d':
          requestData.dir = '1';
          requestData.order = '3';
          break;
        default:
          requestData.dir = undefined;
          requestData.order = blockConfig.order;
          break;
      }
    }
    let temp;
    for (let id in this.state.filter) {
      temp = this.state.filter[id];
      if (temp == undefined) {
        continue;
      }
      switch (id) {
        case 'maxHeight':
        case 'maxWidth':
        case 'medium':
        case 'minHeight':
        case 'minWidth':
          let count = 0;
          temp.forEach(function (value) {
            requestData[`${id}[${count}]`] = value;
            count++;
          });
          break;
        case 'order':
          if (temp == 0) {
            // Default sort -> Use order from block config
            break;
          }
        // Intentional fallthrough
        default:
          requestData[id] = temp;
          break;
      }
    }

    if (this.props.builder) {
      requestData.limit = (blockConfig.columns || defaultColumnCount) * 3;
      if (requestData.maxLimit < requestData.limit) {
        requestData.limit = requestData.maxLimit
      }
    }
  }

  handleResponseDataPostProcess(data) {
    const blockConfig = this.props.onNormalizeBlockConfig(this.props);
    if (blockConfig.maxLimit && data.inventory && data.inventory.length >= blockConfig.maxLimit) {
      data.hasMore = false;
    }
  }

  handleResponseDataPreProcess(responseData) {
    if (!responseData.inventory) {
      return;
    }
    responseData.inventory.forEach((d) => {
      if (d.images.length > 0) {
        d.inventoryLargeImageUrl = Image.url(d.images[0], 1920);
      }
      if (this.props.config && this.props.config.contact) {
        let subject = `Website inquiry regarding ${d.title}`;
        if (!this.state.isArtist && d.artist) {
          subject += ` by ${d.artist.name}`;
        }
        if (d.number && d.number.toString().length > 0) {
          subject += ` (Inv# ${d.number})`;
        }
        if (d.sku && d.sku.toString().length > 0) {
          subject += ` (SKU ${d.sku})`;
        }
        subject = encodeURIComponent(subject);

        const message = encodeURIComponent(
          "I'm interested in learning more about this piece."
        );
        const query = `sub=${this.props.config.subdomain}&inventoryId=${d.id}&message=${message}&subject=${subject}`;
        d.contactUrl = `/${this.props.config.contact.relativeUrl}?${query}`;
      }
      d._title = d.title;
      if (this.props.legacy && d.subtitle) {
        d.title = d.title + d.subtitle;
      }
    });
  }

  handleTabClick(tab) {
    if (!tab || !this.props.blockIdentifier) {
      return;
    }
    if (location && !this.props.builder) {
      if (tab.anchorName) {
        location.hash = `#${tab.anchorName}`;
      } else {
        location.hash = '';
      }
    }
    this.props.onTabClick(tab);
  }

  render() {
    const isEmpty = this.props.data && (!this.props.data.inventory || this.props.data.inventory.length == 0);
    if (!this.props.builder && isEmpty) {
      let hasFilter = false;
      let temp;
      for (let id in this.state.filter) {
        switch (id) {
          case 'dir':
          case 'order':
            // Not part of the actual filter
            break;
        }
        temp = this.state.filter[id];
        if (temp == undefined) {
          continue;
        }
        hasFilter = true;
        break;
      }
      if (!hasFilter) {
        return null;
      }
    }
    const style = { position: 'relative' };
    let tabProps, textAlignFilter, textAlignTabs;
    let backgroundColor = this.props.backgroundColor;
    let styleFilter = {};
    let styleFilterContainer = {};
    let styleTabs = {};
    let styleTabsContainer = {};
    if (this.props.blockConfig) {
      if (this.props.blockConfig.layout) {
        Block.mapStyleConfigProps(style, this.props.blockConfig.layout, (propName, propValue, propUnit) => {
          switch (propName) {
            case 'alignmentTabs':
              textAlignTabs = propValue;
              return true;
            case 'backgroundColor':
              backgroundColor = propValue || backgroundColor;
              break;
            case 'marginBottomFilter':
            case 'marginLeftFilter':
            case 'marginRightFilter':
            case 'marginTopFilter':
            case 'paddingBottomFilter':
            case 'paddingLeftFilter':
            case 'paddingRightFilter':
            case 'paddingTopFilter':
              if (!propValue || !propUnit) {
                return true;
              }
              if (!styleFilter) {
                styleFilter = {};
              }
              styleFilter[propName.replace('Filter', '')] = `${propValue}${propUnit}`;
              return true;
            case 'marginBottomTabs':
            case 'marginLeftTabs':
            case 'marginRightTabs':
            case 'marginTopTabs':
            case 'paddingBottomTabs':
            case 'paddingLeftTabs':
            case 'paddingRightTabs':
            case 'paddingTopTabs':
              if (!propValue || !propUnit) {
                return true;
              }
              if (!styleTabs) {
                styleTabs = {};
              }
              styleTabs[propName.replace('Tabs', '')] = `${propValue}${propUnit}`;
              return true;
            case 'maxWidthFilter':
              if (propValue && propUnit) {
                styleFilterContainer = { maxWidth: `${propValue}${propUnit}` };
              }
              return true;
            case 'maxWidthTabs':
              if (propValue && propUnit) {
                styleTabsContainer = { maxWidth: `${propValue}${propUnit}` };
              }
              return true;
            case 'textAlignFilter':
              textAlignFilter = propValue;
              return true
            case 'textAlignTabs':
              if (!styleTabs) {
                styleTabs = {};
              }
              if (propValue) {
                styleTabs[propName.replace('Tabs', '')] = propValue;
              }
              return true;
          }
        });
      }
      if (this.props.blockConfig.filter) {
        if (!styleFilter) {
          styleFilter = {};
        }
        Block.mapStyleConfigProps(styleFilter, this.props.blockConfig.filter, (propName, propValue, propUnit) => {
          switch (propName) {
            case 'hasArtistState':
            case 'hasColor':
            case 'hasDimensions':
            case 'hasFilter':
            case 'hasMedium':
            case 'hasPrice':
            case 'hasQ':
            case 'hasSort':
            case 'hasStatus':
              return true;
            case 'maxWidth':
              if (propValue && propUnit) {
                styleFilterContainer = { maxWidth: `${propValue}${propUnit}` };
              }
              return true;
            case 'textAlign':
              textAlignFilter = propValue;
              return true;
          }
        });
      }
      if (this.props.blockConfig.tabLayout) {
        tabProps = {
          design: this.props.blockConfig.tabLayout.design,
          styleSeparator: "",
          tabComponent: TabV2
        };
        if (!styleTabs) {
          styleTabs = {};
        }
        Block.mapStyleConfigProps(styleTabs, this.props.blockConfig.tabLayout, (propName, propValue, propUnit) => {
          switch (propName) {
            case 'alignment':
              textAlignTabs = propValue;
              return true;
            case 'colorActive':
              tabProps.activeTabColor = propValue;
              return true;
            case 'design':
              return true;
            case 'maxWidth':
              if (propValue && propUnit) {
                styleTabsContainer = { maxWidth: `${propValue}${propUnit}` };
              }
              return true;
            case 'separatorColor':
              tabProps.styleSeparator += `background-color:${propValue};`;
              return true;
            case 'separatorHeight':
              if (propValue && propUnit) {
                tabProps.styleSeparator += `height:${propValue}${propUnit};`;
              }
              return true;
            case 'separatorWidth':
              if (propValue && propUnit) {
                tabProps.styleSeparator += `width:${propValue}${propUnit};`;
              }
              return true;
            case 'tabSpacing':
              if (propValue == undefined || propUnit == undefined) {
                return true;
              }
              tabProps.spacing = propValue;
              return true;
            case 'textAlign':
              styleTabs.justifyContent = propValue;
              return true;
          }
        });
      }
      if (!this.props.inCell) {
        styleFilter = Kit.Page.updateComponentStyle(styleFilter, this.props.config, this.props.pageType);
        if (!styleFilterContainer.maxWidth) {
          styleFilterContainer = {
            maxWidth: Kit.Page.maxWidth(this.props.config, this.props.pageType)
          };
        }
        styleTabs = Kit.Page.updateComponentStyle(styleTabs, this.props.config, this.props.pageType);
        if (!styleTabsContainer.maxWidth) {
          styleTabsContainer = {
            maxWidth: Kit.Page.maxWidth(this.props.config, this.props.pageType)
          };
        }
      }
      styleFilterContainer = Block.updateAlignment(styleFilterContainer, textAlignFilter);
      styleTabsContainer = Block.updateAlignment(styleTabsContainer, textAlignTabs);
    }
    if (this.props.builder && isEmpty) {
      let blankState;
      if (this.props.onBlankState) {
        blankState = this.props.onBlankState(Name.Block.Inventory.ListV2);
      }
      if (blankState) {
        return blankState;
      }
      return (
        <React.Fragment>
          {
            !this.props.legacy &&
            <LayoutTabSelectionDropDown
              key="selector"
              tab={this.props.tab}
              tabs={this.props.tabs}
              onBlockMove={this.props.onBlockMove}
              onSelect={this.props.onTabClick} />
          }
          <ContentContainer style={style}>
            <EmptyContentPlaceholder>You haven't added any inventory yet. Once you do, you'll see them here.</EmptyContentPlaceholder>
          </ContentContainer>
        </React.Fragment>
      );
    }
    let Content;
    switch (this.props.tab) {
      case Layout.Type.Result.HorizontalMasonry:
        Content = HorizontalMasonry;
        break;
      case Layout.Type.Result.Pinterest:
        Content = Waterfall;
        break;
      case Layout.Type.Result.Thumbnails:
        Content = Grid;
        break;
    }
    const contentProps = {
      backgroundColor,
      blockConfig: this.props.blockConfig,
      blockIdentifier: this.props.blockIdentifier,
      builder: this.props.builder,
      config: this.props.config,
      frameDoc: this.props.frameDoc,
      hasMore: this.props.data && this.props.data.hasMore,
      inCell: this.props.inCell,
      isArtist: this.state.isArtist,
      legacy: this.props.legacy,
      listData: this.props.data && this.props.data.inventory,
      pageType: this.props.pageType,
      queryDataSub: this.props.queryDataSub,
      queryLayout: this.props.queryLayout,
      querySub: this.props.querySub,
      screenSize: this.state.screenSize,
      onInquire: this.handleInquireModalOpen,
      onLoadMore: this.props.onLoadMore,
      onModalOpen: this.handleInventoryModalOpen,
      onNormalizeBlockConfig: this.props.onNormalizeBlockConfig,
      onOffer: this.handleOfferModalOpen,
      onPurchase: this.handlePurchaseModalOpen
    };
    let _hasFilter = this.state.hasFilter;
    if (this.props.builder) {
      _hasFilter = this._hasFilter(this.props);
    }
    const blockConfig = this.props.onNormalizeBlockConfig(this.props);
    const tabIncludes = {}
    if (blockConfig.hasHorizontalMasonryLayout) {
      tabIncludes[Layout.Type.Result.HorizontalMasonry] = true;
    }
    if (blockConfig.hasPinterestLayout) {
      tabIncludes[Layout.Type.Result.Pinterest] = true;
    }
    if (blockConfig.hasSlideshowLayout) {
      tabIncludes[Layout.Type.Result.Slideshow] = true;
    }
    if (blockConfig.hasThumbnailsLayout) {
      tabIncludes[Layout.Type.Result.Thumbnails] = true;
    }
    let _tabs = this.props.tabs;
    let tabs, tabsClassName;
    if (tabProps) {
      tabsClassName = 'tabs__container';
      _tabs = this._generateTabs();
      let tabAlignment = 'center';
      switch (styleTabs.justifyContent) {
        case 'flex-end':
          tabAlignment = 'right';
          break;
        case 'flex-start':
          tabAlignment = 'left';
          break;
      }
      tabs = (
        <div className="tabs__wrapper" style={styleTabs}>
          <LayoutTabs
            alignment={tabAlignment}
            blockConfig={blockConfig}
            builder={this.props.builder}
            includes={tabIncludes}
            spacing={tabProps.spacing}
            tab={this.props.tab}
            tabs={_tabs}
            onTabClick={this.handleTabClick}
            {...tabProps} />
        </div>
      )
    } else {
      tabs = (
        <LayoutTabs
          blockConfig={blockConfig}
          builder={this.props.builder}
          includes={tabIncludes}
          style={styleTabs}
          tab={this.props.tab}
          tabs={_tabs}
          onTabClick={this.props.onTabClick} />
      )
    }
    if (_tabs.length <= 1) {
      tabsClassName = tabsClassName ? `${tabsClassName} dn` : 'dn';
    }
    let modalPageConfig;
    if (this.state.inventoryModal && this.state.inventoryModal.visible) {
      modalPageConfig = this.props.config && this.props.config.documents && this.props.config.documents[PageType.InventoryDetailModal];
      if (blockConfig.useDefaultModalDesign != true && blockConfig.modalDesign) {
        modalPageConfig = blockConfig.modalDesign;
      }
    }
    return (
      <React.Fragment>
        {
          this.props.builder &&
          !this.props.legacy &&
          <LayoutTabSelectionDropDown
            key="selector"
            tab={this.props.tab}
            tabs={this.props.tabs}
            onBlockMove={this.props.onBlockMove}
            onSelect={this.props.onTabClick} />
        }
        {
          _hasFilter &&
          (this.props.builder || this.props.q) &&
          <div style={styleFilterContainer}>
            <Filters
              backgroundColor={this.props.backgroundColor}
              builder={this.props.builder}
              config={this.props.config}
              filterConfig={this._getFilterConfig(this.props)}
              initialFilter={this.state.filter}
              isArtist={this.state.isArtist || (this.props.context && this.props.context.artistId != undefined)}
              style={styleFilter}
              onFilterChange={this.handleFilterChange} />
          </div>
        }
        {
          (this.props.builder || _tabs && _tabs.length > 1) &&
          <div className={tabsClassName} style={styleTabsContainer}>
            {tabs}
          </div>
        }
        <div className="tabs__content tabs__content--inventory current" style={style}>
          {
            !this.props.data &&
            <LoadingView />
          }
          {
            this.props.data &&
            <React.Fragment>
              {
                this.props.tab != Layout.Type.Result.Slideshow &&
                <React.Fragment>
                  <Content {...contentProps} />
                  <Footer
                    builder={this.props.builder}
                    hasMore={this.props.data.hasMore}
                    loading={this.props.loading}
                    onLoadMore={this.props.onLoadMore} />
                </React.Fragment>
              }
              {
                blockConfig.hasSlideshowLayout &&
                <Slideshow
                  {...contentProps}
                  dotsEnabled={true}
                  navEnabled={this.props.v3}
                  responsive={this.props.v3}
                  slideSelector=".slide__cont"
                  v3={this.props.v3}
                  visible={this.props.tab == Layout.Type.Result.Slideshow} />
              }
            </React.Fragment>
          }
        </div>
        {
          this.state.inventoryModal &&
          this.state.inventoryModal.visible &&
          <InventoryModal
            blockIdentifier={this.props.blockIdentifier}
            config={this.props.config || {}}
            data={this.props.data.inventory}
            imageSize={this.props.imageSize}
            inventoryId={this.state.inventoryModal.inventoryId}
            isArtist={this.state.isArtist}
            pageConfig={modalPageConfig}
            querySub={this.props.querySub}
            showPrice={this.state.showPrice}
            sub={this.props.config.subdomain}
            onClose={this.handleInventoryModalClose}
            onInquire={this.handleInquireModalOpen}
            onOffer={this.handleOfferModalOpen}
            onPurchase={this.handlePurchaseModalOpen} />
        }
        {
          this.state.inquireModal &&
          this.state.inquireModal.visible &&
          <InquirePopup
            builder={this.props.builder}
            config={this.props.config}
            inventory={this.state.inquireModal.inventory}
            sub={this.props.config.subdomain}
            onClose={this.handleInquireModalClose} />
        }
        {
          this.state.offerModal &&
          this.state.offerModal.visible &&
          <OfferPopup
            builder={this.props.builder}
            config={this.props.config}
            inventory={this.state.offerModal.inventory}
            localization={this.props.config.localization}
            sub={this.props.config.subdomain}
            onClose={this.handleOfferModalClose} />
        }
        {
          this.state.purchaseModal &&
          this.state.purchaseModal.visible &&
          <PurchasePopup
            builder={this.props.builder}
            config={this.props.config}
            inventory={this.state.purchaseModal.inventory}
            querySub={this.props.querySub}
            sub={this.props.config.subdomain}
            onClose={this.handlePurchaseModalClose} />
        }
        <JsonLD
          baseUrl={this.props.baseUrl}
          builder={this.props.builder}
          jsonLD={this.props.jsonLD}
          path="art"
          querySub={this.props.querySub} />
      </React.Fragment>
    );
  }
}
const InventoryListV1Component =
  withConfig(
    withPaging(
      withLayoutTabOptions(_InventoryListV1Component),
      { path: 'inventory', resultKey: 'inventory', onCheckFilter: hasInventoryListFilter }));
const InventoryListV1 = { Component: InventoryListV1Component };

// region INVENTORY LIST V2

function _InventoryListV2Component(props) {
  return <_InventoryListV1Component {...props} />
}
const InventoryListV2Component =
  withConfig(
    withPaging(
      withLayoutTabOptions(_InventoryListV2Component),
      { path: 'inventory', resultKey: 'inventory', onCheckFilter: hasInventoryListFilter }));
const InventoryListV2 = { Component: InventoryListV2Component };

function _InventoryListV3Component(props) {
  return <_InventoryListV2Component {...props} v3={true} />
}
const InventoryListV3Component =
  withConfig(
    withPaging(
      withLayoutTabOptions(_InventoryListV3Component),
      { path: 'inventory', resultKey: 'inventory', onCheckFilter: hasInventoryListFilter }));
const InventoryListV3 = { Component: InventoryListV3Component };

function ContentContainer(props) {
  return (
    <_ContentContainer className={props.className} style={props.style} type="inventory">
      {props.children}
    </_ContentContainer>
  );
}

// #region FILTER

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.sortOptions = [
      { id: 'sort', display: 'Default sort', order: 0 },
      { id: 'priceAsc', dir: 0, display: 'Price: Low to High', order: 3 },
      { id: 'priceDesc', dir: 1, display: 'Price: High to Low', order: 3 }
    ];
    if (props.config && props.config.userType != 1) {
      this.sortOptions.push({ id: 'artistAsc', dir: 0, display: 'Artist: A to Z', order: 5 });
      this.sortOptions.push({ id: 'artistDesc', dir: 1, display: 'Artist: Z to A', order: 5 });
    }
    this.sortOptions.push({ id: 'titleAsc', dir: 0, display: 'Title: A to Z', order: 4 });
    this.sortOptions.push({ id: 'titleDesc', dir: 1, display: 'Title: Z to A', order: 4 });

    this.statusOptions = [
      { id: 'all', display: 'Show All' },
      { id: 'available', display: 'Only Available', value: 5 }
    ];

    const mediumList = props.filterConfig.mediumList || Defaults.Block[Name.Block.Inventory.ListV3].MediumList;
    const medium = mediumList.map(d => ({ id: d.value, checked: false, display: d.display }))
    this.state = {
      options: {
        color: [
          { id: '#d10000', checked: false, display: 'Red' },
          { id: '#ff6622', checked: false, display: 'Orange' },
          { id: '#ffda21', checked: false, display: 'Yellow' },
          { id: '#33dd00', checked: false, display: 'Green' },
          { id: '#1133cc', checked: false, display: 'Blue' },
          { id: '#220066', checked: false, display: 'Purple' },
          { id: '#000000', checked: false, display: 'Black' },
          { id: '#ffffff', checked: false, display: 'White' }
        ],
        medium,
        size: [
          { id: 'small', checked: false, display: 'Small' },
          { id: 'medium', checked: false, display: 'Medium' },
          { id: 'large', checked: false, display: 'Large' }
        ]
      },
      sort: this.sortOptions[0],
      status: this.statusOptions[0]
    };

    this._handleFilterChange = this._handleFilterChange.bind(this);
    this._handleFilterChangeDebounced = this._handleFilterChangeDebounced.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleChipRemove = this.handleChipRemove.bind(this);
    this.handleDropDownCheckboxSelect = this.handleDropDownCheckboxSelect.bind(this);
    this.handleDropDownClick = this.handleDropDownClick.bind(this);
    this.handleDropDownSelect = this.handleDropDownSelect.bind(this);
    this.handleFilterShow = this.handleFilterShow.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  componentDidMount() {
    if (this.props.initialFilter) {
      let activeSort = this.state.sort;
      let activeStatus = this.state.status;
      let temp;
      for (let i = 0; i < this.sortOptions.length; i++) {
        temp = this.sortOptions[i];
        if (!temp || temp.order != this.props.initialFilter.order || temp.dir != this.props.initialFilter.dir) {
          continue;
        }
        activeSort = temp;
        break;
      }
      for (let i = 0; i < this.statusOptions.length; i++) {
        temp = this.statusOptions[i];
        if (!temp || temp.value != this.props.initialFilter.status) {
          continue;
        }
        activeStatus = temp;
        break;
      }
      const options = this.state.options;
      this._initializeFilter(this.props.initialFilter, options, 'color');
      this._initializeFilter(this.props.initialFilter, options, 'medium');
      this._initializeFilter(this.props.initialFilter, options, 'size');
      this.setState({
        artistState: this.props.initialFilter.artistState,
        maxPrice: this.props.initialFilter.maxPrice,
        minPrice: this.props.initialFilter.minPrice,
        options,
        q: this.props.initialFilter.q,
        sort: activeSort,
        status: activeStatus
      });
    }
  }

  componentWillUnmount() {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = undefined;
    }
  }

  _handleFilterChange() {
    const filter = {
      dir: this.state.sort.dir,
      order: this.state.sort.order
    };
    if (this.state.status.value) {
      filter.status = this.state.status.value;
    }

    let d;
    for (let i = 0; i < this.state.options.color.length; i++) {
      d = this.state.options.color[i];
      if (!d.checked) {
        continue;
      }
      filter.color = d.id;
      break;
    }

    filter.medium = [];
    this.state.options.medium.forEach(function (d) {
      if (!d.checked) {
        return;
      }
      filter.medium.push(d.id);
    });
    filter.maxHeight = [];
    filter.maxWidth = [];
    filter.minHeight = [];
    filter.minWidth = [];
    for (let i = 0; i < this.state.options.size.length; i++) {
      d = this.state.options.size[i];
      if (!d.checked) {
        continue;
      }
      switch (d.id) {
        case 'small':
          filter.maxHeight.push(sizeBuckets.small.max);
          filter.maxWidth.push(sizeBuckets.small.max);
          filter.minHeight.push(sizeBuckets.small.min);
          filter.minWidth.push(sizeBuckets.small.min);
          break;
        case 'medium':
          filter.maxHeight.push(sizeBuckets.medium.max);
          filter.maxWidth.push(sizeBuckets.medium.max);
          filter.minHeight.push(sizeBuckets.medium.min);
          filter.minWidth.push(sizeBuckets.medium.min);
          break;
        case 'large':
          filter.maxHeight.push(sizeBuckets.large.max);
          filter.maxWidth.push(sizeBuckets.large.max);
          filter.minHeight.push(sizeBuckets.large.min);
          filter.minWidth.push(sizeBuckets.large.min);
          break;
      }
    }

    if (this.state.maxPrice != undefined && this.state.maxPrice.length > 0) {
      filter.maxPrice = this.state.maxPrice;
    }
    if (this.state.minPrice != undefined && this.state.minPrice.length > 0) {
      filter.minPrice = this.state.minPrice;
    }
    if (this.state.q != undefined && this.state.q.length > 0) {
      filter.q = this.state.q;
    }
    if (this.state.artistState != undefined && this.state.artistState.length > 0) {
      filter.artistState = this.state.artistState;
    }
    this.props.onFilterChange(filter);
  }

  _handleFilterChangeDebounced(immediate) {
    if (!this.props.onFilterChange || this.state.filterVisible) {
      return;
    }
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = undefined;
    }
    if (immediate == true) {
      this._handleFilterChange();
    } else {
      this._timeoutId = setTimeout(this._handleFilterChange, 1000);
    }
  }

  _initializeFilter(filter, options, name) {
    if (!filter || !options || !name) {
      return;
    }
    const filterOptions = options[name];
    if (!filterOptions) {
      return;
    }
    switch (name) {
      case 'medium':
        let filters = [].concat(filter[name]);
        filterOptions.forEach(function (d) {
          for (let i = 0; i < filters.length; i++) {
            if (filters[i] != d.id) {
              continue;
            }
            d.checked = true;
            filters.splice(i, 1);
            break;
          }
        });
        break;
      case 'size':
        let maxHeight = [].concat(filter.maxHeight);
        let maxWidth = [].concat(filter.maxWidth);
        let minHeight = [].concat(filter.minHeight);
        let minWidth = [].concat(filter.minWidth);
        filterOptions.forEach(function (d) {
          for (let i = 0; i < minWidth.length; i++) {
            let sizeId;
            switch (minWidth[i]) {
              case sizeBuckets.small.min:
                sizeId = 'small';
                break;
              case sizeBuckets.medium.min:
                sizeId = 'medium';
                break;
              case sizeBuckets.large.min:
                sizeId = 'large';
                break;
            }
            if (sizeId != d.id) {
              continue;
            }
            d.checked = true;
            maxHeight.splice(i, 1);
            maxWidth.splice(i, 1);
            minHeight.splice(i, 1);
            minWidth.splice(i, 1);
            break;
          }
        });
        break;
      default:
        const filterId = filter[name];
        if (!filterId) {
          return;
        }
        let temp;
        for (let i = 0; i < filterOptions.length; i++) {
          temp = filterOptions[i];
          if (!temp || temp.id != filterId) {
            continue;
          }
          temp.checked = true;
          break;
        }
        break;
    }
  }

  handleApply() {
    this._handleFilterChange();

    this.setState({
      filterVisible: false
    });
  }

  handleChipRemove(name, id) {
    const handler = this._handleFilterChange;
    switch (name) {
      case 'artistState':
      case 'maxPrice':
      case 'minPrice':
      case 'q':
        this.setState({
          [name]: ''
        }, handler);
        break;
      case 'color':
      case 'medium':
      case 'size':
        const _options = this.state.options;
        const options = _options[name];
        let temp;
        for (let i = 0; i < options.length; i++) {
          temp = options[i];
          if (!temp || temp.id != id) {
            continue;
          }
          temp.checked = false;
          break;
        }
        this.setState({
          options: _options
        }, handler);
        break;
      default:
        handler();
        break;
    }
  }

  handleDropDownCheckboxSelect(name, id) {
    const options = this.state.options;
    const dropDownOptions = options[name];
    if (!dropDownOptions) {
      return;
    }
    let temp;
    for (let i = 0; i < dropDownOptions.length; i++) {
      temp = dropDownOptions[i];

      if (name == 'color') {
        // SINGLE-SELECT IMPLEMENTATION
        if (!temp) {
          continue;
        }
        if (temp.id == id) {
          temp.checked = !temp.checked;
        } else {
          temp.checked = false;
        }
      } else {
        // MULTI-SELECT IMPLEMENTATION
        if (!temp || temp.id != id) {
          continue;
        }
        temp.checked = !temp.checked;
        break;
      }
    }
    this.setState({
      options
    }, this._handleFilterChangeDebounced);
  }

  handleDropDownClick(name) {
    let activeDropDown;
    if (!this.state.activeDropDown) {
      activeDropDown = name;
    }
    this.setState({
      activeDropDown
    });
  }

  handleDropDownSelect(name, id) {
    switch (name) {
      case 'sort':
      case 'status':
        const optionsName = `${name}Options`;
        const options = this[optionsName] || [];
        let temp;
        for (let i = 0; i < options.length; i++) {
          temp = options[i];
          if (!temp || temp.id != id) {
            continue;
          }

          let handler;
          if (this.state[name].id != temp.id) {
            handler = () => this._handleFilterChangeDebounced(true)
          }
          this.setState({
            activeDropDown: undefined,
            [name]: temp
          }, handler);
          break;
        }
        break;
      default:
        this.handleDropDownCheckboxSelect(name, id);
    }
  }

  handleFilterShow() {
    this.setState({
      filterVisible: true
    });
  }

  handleTextChange(name, value) {
    this.setState({
      [name]: value
    }, () => this._handleFilterChangeDebounced(true));
  }

  render() {
    const backgroundColor = this.props.backgroundColor;
    const filterConfig = this.props.filterConfig || {};
    const filters = (
      <div className="filters" style={this.props.style}>
        <Container className="filters__cont">
          <Row className="cont__row--mobile">
            <Clickable
              className="btn btn--outl btn--sm"
              onClick={this.handleApply}>
              Close
            </Clickable>
          </Row>
          <Row>
            {
              filterConfig.hasQ &&
              <Column className="col--tight col--search" size="3">
                <FilterInput
                  disabled={this.props.builder}
                  name="q"
                  placeholder={`Search for artwork${!this.props.isArtist ? ' & artists' : ''}`}
                  value={this.state.q}
                  onBlur={this.handleTextChange}>
                  <div className="i i-search search__btn--icon filters__icon--search" />
                </FilterInput>
              </Column>
            }
            {
              filterConfig.hasPrice &&
              <Column className="col--tight">
                <div className="filters__range">
                  <label className="filters__range__label">Price:</label>
                  <FilterInput
                    allowDecimals={true}
                    className="filters__range__input"
                    disabled={this.props.builder}
                    name="minPrice"
                    numeric={true}
                    placeholder="min"
                    value={this.state.minPrice}
                    onBlur={this.handleTextChange} />
                  <div className="filters__range__dash">&mdash;</div>
                  <FilterInput
                    allowDecimals={true}
                    className="filters__range__input"
                    disabled={this.props.builder}
                    name="maxPrice"
                    numeric={true}
                    placeholder="max"
                    value={this.state.maxPrice}
                    onBlur={this.handleTextChange} />
                </div>
              </Column>
            }
            {
              filterConfig.hasColor &&
              <Column className="col--tight">
                <DropDown
                  active={this.state.activeDropDown == 'color'}
                  backgroundColor={backgroundColor}
                  label="Color"
                  name="color"
                  options={this.state.options.color}
                  onClick={this.handleDropDownClick}
                  onSelect={this.handleDropDownSelect} />
              </Column>
            }
            {
              filterConfig.hasMedium &&
              <Column className="col--tight">
                <DropDown
                  active={this.state.activeDropDown == 'medium'}
                  backgroundColor={backgroundColor}
                  label="Medium"
                  name="medium"
                  options={this.state.options.medium}
                  onClick={this.handleDropDownClick}
                  onSelect={this.handleDropDownSelect} />
              </Column>
            }
            {
              filterConfig.hasDimensions &&
              <Column className="col--tight">
                <DropDown
                  active={this.state.activeDropDown == 'size'}
                  backgroundColor={backgroundColor}
                  label="Size"
                  name="size"
                  options={this.state.options.size}
                  onClick={this.handleDropDownClick}
                  onSelect={this.handleDropDownSelect} />
              </Column>
            }
            {
              filterConfig.hasStatus &&
              <Column className="col--tight col--status">
                <DropDown
                  active={this.state.activeDropDown == 'status'}
                  backgroundColor={backgroundColor}
                  checkable={false}
                  label={this.state.status.display}
                  name="status"
                  options={this.statusOptions}
                  onClick={this.handleDropDownClick}
                  onSelect={this.handleDropDownSelect} />
              </Column>
            }
            {
              filterConfig.hasArtistState &&
              <Column className="col--tight col--artist__state">
                <FilterInput
                  disabled={this.props.builder}
                  name="artistState"
                  placeholder="Artist state"
                  value={this.state.artistState}
                  onBlur={this.handleTextChange}>
                  <div className="i i-search search__btn--icon filters__icon--search" />
                </FilterInput>
              </Column>
            }
            {
              filterConfig.hasSort &&
              <Column className="col--tight">
                <DropDown
                  active={this.state.activeDropDown == 'sort'}
                  backgroundColor={backgroundColor}
                  checkable={false}
                  label={this.state.sort.display}
                  name="sort"
                  options={this.sortOptions}
                  onClick={this.handleDropDownClick}
                  onSelect={this.handleDropDownSelect} />
              </Column>
            }
          </Row>
        </Container>
      </div>
    );

    const chips = [];
    if (filterConfig.hasQ && this.state.q && this.state.q.length) {
      chips.push(
        <FilterChip key="q" name="q" onRemove={this.handleChipRemove}>
          <React.Fragment>Search Term is '{this.state.q}'</React.Fragment>
        </FilterChip>
      );
    }
    if (filterConfig.hasPrice) {
      if (this.state.minPrice && this.state.minPrice.length) {
        chips.push(
          <FilterChip
            key="minPrice"
            name="minPrice"
            onRemove={this.handleChipRemove}>
            <React.Fragment>
              Price is &gt;= {this.state.minPrice}
            </React.Fragment>
          </FilterChip>
        );
      }
      if (this.state.maxPrice && this.state.maxPrice.length) {
        chips.push(
          <FilterChip
            key="maxPrice"
            name="maxPrice"
            onRemove={this.handleChipRemove}>
            <React.Fragment>
              Price is &lt;= {this.state.maxPrice}
            </React.Fragment>
          </FilterChip>
        );
      }
    }
    if (filterConfig.hasColor) {
      this.state.options.color.forEach((d) => {
        if (!d.checked) {
          return;
        }
        chips.push(
          <FilterChip
            key={d.id}
            id={d.id}
            name="color"
            onRemove={this.handleChipRemove}>
            <React.Fragment>Color is {d.display}</React.Fragment>
          </FilterChip>
        );
      });
    }
    if (filterConfig.hasMedium) {
      this.state.options.medium.forEach((d) => {
        if (!d.checked) {
          return;
        }
        chips.push(
          <FilterChip
            key={d.id}
            id={d.id}
            name="medium"
            onRemove={this.handleChipRemove}>
            <React.Fragment>Medium is {d.display}</React.Fragment>
          </FilterChip>
        );
      });
    }
    if (filterConfig.hasDimensions) {
      this.state.options.size.forEach((d) => {
        if (!d.checked) {
          return;
        }
        chips.push(
          <FilterChip
            key={d.id}
            id={d.id}
            name="size"
            onRemove={this.handleChipRemove}>
            <React.Fragment>Size is {d.display}</React.Fragment>
          </FilterChip>
        );
      });
    }
    if (filterConfig.hasArtistState && this.state.artistState && this.state.artistState.length) {
      chips.push(
        <FilterChip
          key="artistState"
          name="artistState"
          onRemove={this.handleChipRemove}>
          <React.Fragment>
            Artist State is '{this.state.artistState}'
          </React.Fragment>
        </FilterChip>
      );
    }
    let styleChips;
    if (chips.length > 0 && this.props.style) {
      styleChips = {
        marginLeft: this.props.style.marginLeft,
        marginRight: this.props.style.marginRight,
        maxWidth: this.props.style.maxWidth,
        paddingLeft: this.props.style.paddingLeft,
        paddingRight: this.props.style.paddingRight
      };
    }
    return (
      <React.Fragment>
        <div className="filters--mobile" style={this.props.style}>
          <Clickable
            className="btn btn--outl btn--sm btn--inventory--filter"
            onClick={this.handleFilterShow}>
            Filter
          </Clickable>
          {this.state.filterVisible && filters}
        </div>
        {filters}
        <div className="filters__chip__cont cont" style={styleChips}>{chips}</div>
      </React.Fragment>
    );
  }
}

class FilterChip extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.onRemove(this.props.name, this.props.id);
  }

  render() {
    return (
      <div className="filters__chip" onClick={this.handleClick}>
        <span className="label">{this.props.children}</span>
        <span className="close">
          <span>X</span>
        </span>
      </div>
    );
  }
}

class FilterInput extends React.Component {
  constructor(props) {
    super(props);

    const value = props.value || '';
    this.state = {
      initialValue: value,
      value: value
    };

    this._handleRef = this._handleRef.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidUpdate() {
    if (this.props.value != undefined && this.props.value != this.state.initialValue) {
      this.setState({
        initialValue: this.props.value,
        value: this.props.value
      });
    }
  }

  _handleRef(ref) {
    this.inputRef = ref;
  }

  handleBlur() {
    if (!this.props.onBlur || this.state.value == this.state.initialValue) {
      return;
    }
    this.props.onBlur(this.props.name, this.state.value);
  }

  handleChange(event) {
    this.setState({
      value: event.currentTarget.value
    });
  }

  handleFocus() {
    const value = this.props.value || '';
    this.setState({
      initialValue: value,
      value
    });
  }

  handleKeyPress(event) {
    if (event.which == 13) {
      // Enter key
      if (this.inputRef) {
        this.inputRef.blur();
      }
      return;
    }
    if (!this.props.numeric) {
      return;
    }
    if (this.props.allowDecimals && event.which == 46) {
      const text = (this.props.value || '') + '';
      if (text && text.indexOf('.') >= 0) {
        event.preventDefault();
      }
      return;
    }
    if (event.which < 48 || event.which > 57) {
      event.preventDefault();
    }
  }

  render() {
    let className = 'input input--outl input--sm';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }
    return (
      <div className={className}>
        <input
          ref={this._handleRef}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          type={this.props.type || 'text'}
          value={this.state.value}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onKeyPress={this.handleKeyPress} />
        {this.props.children}
      </div>
    );
  }
}

// #endregion FILTER

// #region CELL COMPONENTS

function Details(props) {
  const extended = props.blockConfig.extended || {};
  var indicator;
  if (props.renderSticker) {
    var indicators = extended.indicators || {};
    var soldIndicator = indicators.sold;
    var inactiveIndicator = indicators.inactive;
    if (props.edition.isSold && soldIndicator && soldIndicator.color) {
      indicator = (
        <span
          className="artwork__sold-sticker"
          style={{ backgroundColor: soldIndicator.color }}></span>
      );
    } else if (!props.edition.active && inactiveIndicator && inactiveIndicator.color) {
      indicator = (
        <span
          className="artwork__inactive-sticker"
          style={{ backgroundColor: inactiveIndicator.color }}></span>
      );
    }
  }
  const showFramed = props.edition.isFramed && extended.includes && extended.includes.framed && extended.includes.framed.isVisible;
  const showUnframed = !props.edition.isFramed && extended.includes && extended.includes.unframed && extended.includes.unframed.isVisible;
  let title = props.data._title || props.data.title;
  return (
    <React.Fragment>
      {
        props.renderPurchase &&
        <ClickableButton
          className="btn btn--fill m-b-sm btn--purchase--grid"
          onClick={(_, e) => {
            e.stopPropagation();
            props.onPurchase(props.data);
          }}>
          Add to Cart
        </ClickableButton>
      }
      {
        !props.isArtist &&
        props.data.artist &&
        <h4 className="artwork__artist notranslate">{props.data.artist.name}</h4>
      }
      <h4>
        {indicator}
        <span className="artwork__title notranslate">{title}</span>
        <Subtitle data={props.data} />
      </h4>
      <h4 className="artwork__info__item">{props.data.medium}</h4>
      <h4 className="artwork__info__item">
        <React.Fragment>
          {props.edition.dimensions.display.formatted}
        </React.Fragment>
        <span className="artwork__info__item--altdim">
          {' '}
          ({props.edition.alternateDimensions})
        </span>
      </h4>
      {
        props.blockConfig.showPrice &&
        <h4 className="artwork__info__item">{props.edition.price}</h4>
      }

      {
        showFramed &&
        <h4 className="artwork__info__item">{extended.includes.framed.prefix}</h4>
      }
      {
        showUnframed &&
        <h4 className="artwork__info__item">{extended.includes.unframed.prefix}</h4>
      }
    </React.Fragment>
  );
}

function Cell(props) {
  const edition = InventoryHelper.edition(props.data) || {};

  let canPurchase;
  if (props.config && props.data.available && props.blockConfig.showPrice) {
    canPurchase = props.config.isStripeConnected;
  }

  const details = (
    <div className="aw__item__details">
      <Details
        blockConfig={props.blockConfig}
        data={props.data}
        edition={edition}
        onPurchase={props.onPurchase}
        isArtist={props.isArtist}
        renderPurchase={canPurchase}
        renderSticker={props.blockConfig && props.blockConfig.extended && props.blockConfig.extended.indicators} />
    </div>
  );
  let imageData = {};
  if (props.data.seo) {
    imageData = {
      alt: props.data.seo.imageAlt,
      caption: props.data.seo.imageCaption,
      description: props.data.seo.imageDescription,
      title: props.data.seo.imageTitle
    };
  }
  const image = (
    <div className="aw__item__img">
      <ImageSrcSet
        builder={props.builder}
        config={props.config}
        data={imageData}
        imageTuples={props.imageTuples} />
    </div>
  );

  const style = { cursor: 'pointer', order: props.data.order };
  let renderSpacer = false;
  if (props.listData && props.lineSpacing) {
    if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
      style.marginBottom = props.lineSpacing;
    } else {
      renderSpacer = true;
    }
  }
  if (props.columnCount > 1 && props.columnSpacing && props.columnSpacing.value && props.columnSpacing.unit) {
    const value = (parseFloat(props.columnSpacing.value) || 0) / 2.0;
    style.marginLeft = `${value}${props.columnSpacing.unit}`;
    style.marginRight = `${value}${props.columnSpacing.unit}`;
  }
  const blockConfig = props.onNormalizeBlockConfig(props);
  if (blockConfig.detailDisplay == 0) {
    // Modal
    return (
      <React.Fragment>
        <div
          className="aw__item--inline"
          id={props.data.id}
          style={style}
          onClick={props.onModalOpen}>
          {image}
          {details}
        </div>
      </React.Fragment>
    );
  }
  style.color = 'initial';

  const link = Url.getLink('', `art/${props.data.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
  return (
    <React.Fragment>
      <a href={link} style={style}>
        <div className="aw__item--inline">
          {image}
          {details}
        </div>
      </a>
      {
        renderSpacer &&
        <div className="cell--spacer" style={{ marginBottom: props.lineSpacing }} />
      }
    </React.Fragment>
  );
}

// #endregion CELL COMPONENTS

// #region GRID

function Grid(props) {
  let className = 'cont--kit__wrapper';
  let columnClassName, legacy;
  if (!props.blockConfig.grid) {
    className += ' legacy';
    columnClassName = 'p-b-sm';
    legacy = true;
  } else {
    columnClassName = 'col--custom';
  }
  let animation;
  let columnCount = props.blockConfig.columns || defaultColumnCount;
  if (props.blockConfig.grid) {
    animation = props.blockConfig.grid.animation;

    switch (props.screenSize) {
      case ScreenSize.Mobile:
        columnCount = props.blockConfig.grid.columnsPhone || 2;
        break;
      case ScreenSize.Tablet:
        columnCount = props.blockConfig.grid.columnsTablet || 3;
        break;
      case ScreenSize.Desktop:
      default:
        columnCount = props.blockConfig.grid.columns || columnCount;
        break;
    }
  }
  const columnSize = Layout.columnSize(columnCount);
  const listData = props.listData || [];
  let lineSpacing;
  const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign', configKey: 'grid' }, (propName, propValue, propUnit) => {
    switch (propName) {
      case 'animation':
      case 'cell':
      case 'columns':
      case 'columnsPhone':
      case 'columnsTablet':
      case 'columnSpacing':
      case 'display':
        return true;
      case 'lineSpacing':
        if (propUnit) {
          const value = propValue || 0;
          lineSpacing = `${value}${propUnit}`;
        }
        return true;
    }
  });
  return (
    <ContentContainer className={className} style={layoutStyles.containerStyle}>
      <Spaced className="cont--kit__content" style={layoutStyles.style}>
        <Row className={legacy ? undefined : 'cont__row--custom'}>
          {listData.map((d, i) => (
            <Column
              key={`${i}_${d.id}`}
              className={columnClassName}
              size={columnSize}
              style={props.builder ? { pointerEvents: 'none' } : undefined}>
              <GridCell
                animation={animation}
                columnCount={columnCount}
                columnSpacing={props.blockConfig.grid && props.blockConfig.grid.columnSpacing}
                index={i}
                legacy={legacy}
                lineSpacing={lineSpacing}
                {...props}
                data={d}
                inCell={true} />
            </Column>
          ))}
        </Row>
      </Spaced>
    </ContentContainer>
  );
}

function GridCell(props) {
  if (!props.legacy) {
    return <InventoryListCell.InventoryCellContainer {...props} cellType="grid" contentConfig={Defaults.cellDesign(props.config, props.blockConfig, Kit.Context.Cell.Inventory.Grid)} />
    // return <InventoryListCell.InventoryCellContainer {...props} cellType="grid" contentConfig={props.blockConfig.grid.cell} />
  }
  let image = {};
  if (props.data.images && props.data.images.length > 0) {
    image = props.data.images[0];
  }
  const imageTuples = Image.sizes.map(function (d) {
    let url;
    if (props.blockConfig.hasCroppedThumbnailsLayout) {
      url = Image.url(image, d, d, 'c_fill');
    } else {
      url = Image.url(
        image,
        d,
        d,
        'c_pad',
        undefined,
        props.config && props.config.backgroundColor
      );
    }
    return { size: d, url: url };
  });
  const lineSpacing = props.lineSpacing || '36px';
  return <Cell imageTuples={imageTuples} {...props} lineSpacing={lineSpacing} />;
}

// #endregion GRID

// #region HORIZONAL MASONRY

let _HorizontalMasonryInst;
class HorizontalMasonry extends React.Component {
  constructor(props) {
    super(props);

    this.id = `horiz-masonry-${props.blockIdentifier}`;

    this._layout = this._layout.bind(this);
    this._layoutDebounced = this._layoutDebounced.bind(this);
  }

  componentDidMount() {
    _HorizontalMasonryInst = true;

    if (this.props.builder) {
      return;
    }

    setTimeout(() => {
      if (!_HorizontalMasonryInst) {
        return;
      }
      this._layout();
      window.addEventListener('resize', this._layoutDebounced);
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listData && this.props.listData && prevProps.listData.length != this.props.listData.length) {
      this._layout();
    }
  }

  componentWillUnmount() {
    _HorizontalMasonryInst = undefined;

    window.removeEventListener('resize', this._layoutDebounced);
    if (this._layoutTimeoutId) {
      clearTimeout(this._layoutTimeoutId);
      this._layoutTimeoutId = undefined;
    }
  }

  _layout() {
    if (!this.props.listData) {
      return;
    }
    const container = document.getElementById(this.id);
    if (!container) {
      return;
    }
    const itemElements = container.getElementsByClassName(
      'aw__item--horz-masonry'
    );
    if (!itemElements || itemElements.length < 2) {
      return;
    }
    const inventoryCount = this.props.listData.length;
    const itemElementCount = itemElements.length;
    const rowHeight = this.initialRowHeight || itemElements[0].offsetHeight;
    this.initialRowHeight = rowHeight;

    const containerWidth = container.offsetWidth;
    const itemSpacing = parseInt(getComputedStyle(container.querySelector('.aw__item--horz-masonry')).marginRight);

    const rows = [];
    var current = [];
    let aspectRatio = 0,
      currentItemCount = 0,
      currentRowWidth = 0;
    let d, element, image, imageWidth;
    for (let i = 0; i < itemElementCount; i++) {
      if (i >= inventoryCount) {
        // More elements than inventory...what happened?
        break;
      }
      d = this.props.listData[i];
      if (!d.images || !d.images.length) {
        // Maybe? What do we do if there's no image?
        currentRowWidth += itemSpacing;
        currentItemCount++;
        continue;
      }

      image = d.images[0];
      aspectRatio = 0;
      if (image.height > 0 && image.width > 0) {
        aspectRatio = image.width / image.height;
      }
      element = itemElements[i];

      imageWidth = aspectRatio * rowHeight + itemSpacing;
      if (currentRowWidth + imageWidth < containerWidth) {
        currentRowWidth += imageWidth;
        currentItemCount++;
        current.push({ id: d.id, ratio: aspectRatio });
      } else {
        rows.push({ count: currentItemCount, width: currentRowWidth, ids: current });
        currentRowWidth = imageWidth;
        currentItemCount = 1;
        current = [{ id: d.id, ratio: aspectRatio }];
      }
    }

    currentItemCount = 0;
    let total = 0;
    let height, index, row, img;
    for (let i = 0; i < rows.length; i++) {
      row = rows[i];
      height = Math.floor(
        (rowHeight * (containerWidth - row.count * itemSpacing)) /
        (row.width - row.count * itemSpacing) -
        1
      );

      for (let j = 0; j < row.count; j++) {
        index = currentItemCount + j;
        if (index >= itemElementCount) {
          break;
        }
        this._updateItemElement(itemElements[index], height, row.ids[j].ratio);
        total++;
      }
      currentItemCount += row.count;
    }

    // Process remaining items that didn't fit into a full row, using the default height from CSS
    height = 250;
    for (let i = 0; i < current.length; i++) {
      row = current[i];
      index = total + i;
      if (index >= itemElements.length) {
        break;
      }
      this._updateItemElement(itemElements[index], height, row.ratio);
    }
  }

  _layoutDebounced() {
    if (this._layoutTimeoutId) {
      clearTimeout(this._layoutTimeoutId);
      this._layoutTimeoutId = undefined;
    }
    this._layoutTimeoutId = setTimeout(this._layout, 1000);
  }

  _updateItemElement(element, height, ratio) {
    element.setAttribute('style', `height:${height}px;`);
    element.style.height = `${height}px`;
    const img = element.querySelector('img');
    img.setAttribute('style', `height:${height}px;`);
    img.style.height = `${height}px`;
    img.style.width = `${height * ratio}px`;
    img.classList.add('lazyload');
  }

  render() {
    const props = this.props;
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign', configKey: 'horizontal' });
    if (props.builder) {
      return (
        <div className="center" style={layoutStyles.containerStyle}>
          <div style={layoutStyles.style}>
            <img
              alt="Horizontal Masonry Preview"
              src="https://click.artcloud.com/images/horizontal-masonry-preview.jpg"
              className="center"
              style={{ maxWidth: '100%' }} />
          </div>
        </div>
      );
    }
    const listData = props.listData || [];
    return (
      <ContentContainer className="cont--horz-masonry cont--kit__wrapper" style={layoutStyles.containerStyle}>
        <Spaced className="cont--kit__content" style={layoutStyles.style}>
          <Row id={this.id}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
              {listData.map((d, i) => (
                <HorizontalMasonryCell key={`${i}_${d.id}`} data={d} {...props} />
              ))}
            </div>
          </Row>
        </Spaced>
      </ContentContainer>
    );
  }
}

function HorizontalMasonryCell(props) {
  let _image = {};
  if (props.data.images && props.data.images.length > 0) {
    _image = props.data.images[0];
  }
  let imageData = {};
  if (props.data.seo) {
    imageData = {
      alt: props.data.seo.imageAlt,
      caption: props.data.seo.imageCaption,
      description: props.data.seo.imageDescription,
      title: props.data.seo.imageTitle
    };
  }
  const imageTuples = Image.sizes.map(function (d) {
    const url = Image.url(
      _image,
      d,
      d,
      'c_fit',
      undefined,
      props.config && props.config.backgroundColor
    );
    return { size: d, url: url };
  });
  const image = (
    <ImageSrcSet
      builder={props.builder}
      config={props.config}
      data={imageData}
      imageTuples={imageTuples} />
  );
  const blockConfig = props.onNormalizeBlockConfig(props);
  if (blockConfig.detailDisplay == 0) {
    // Modal
    return (
      <div
        className="aw__item--inline aw__item--horz-masonry"
        id={props.data.id}
        onClick={props.onModalOpen}>
        <div className="aw__item__img aw__item--horz-masonry__img">{image}</div>
      </div>
    );
  }
  const link = Url.getLink('', `art/${props.data.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
  return (
    <a href={link} style={{ color: 'initial', order: props.data.order }}>
      <div className="aw__item--inline aw__item--horz-masonry">
        <div className="aw__item__img aw__item--horz-masonry__img">{image}</div>
      </div>
    </a>
  );
}

// #endregion HORIZONAL MASONRY

// #region SLIDESHOW

function _Slideshow(props) {
  let backgroundColor;
  if (props.config) {
    backgroundColor = props.config.backgroundColor;
  }
  let className = 'cont--inventory';
  let wrapperClassName = 'cont--kit__content';
  if (props.v3) {
    className += ' cont__row';
    wrapperClassName += ' cont--spaced';
  } else {
    className += ' sect--slider';
  }
  let SlideComponent = Slide;
  let contentConfig;
  if (props.blockConfig.slideshow) {
    if (props.blockConfig.slideshow.cell && props.blockConfig.slideshow.cell.desktop && props.blockConfig.slideshow.cell.desktop.blocks && props.blockConfig.slideshow.cell.desktop.blocks.length > 0) {
      contentConfig = props.blockConfig.slideshow.cell;
    } else if (props.v3) {
      contentConfig = Defaults.Block[Name.Block.Inventory.ListV3].SlideshowCell;
    } else {
      contentConfig = Defaults.Block[Name.Block.Inventory.ListV2].SlideshowCell;
    }
    SlideComponent = InventoryListCell.InventoryCellContainer;
    className += ' slider--whitelabel';
  }
  const style = {};
  Utilities.copyObject(props.style, style);
  const wrapperStyle = {}
  if (style.marginLeft) {
    wrapperStyle.marginLeft = style.marginLeft;
    style.marginLeft = undefined;
  }
  if (style.marginRight) {
    wrapperStyle.marginRight = style.marginRight;
    style.marginRight = undefined;
  }
  if (style.paddingLeft) {
    wrapperStyle.paddingLeft = style.paddingLeft;
    style.paddingLeft = undefined;
  }
  if (style.paddingRight) {
    wrapperStyle.paddingRight = style.paddingRight;
    style.paddingRight = undefined;
  }
  const listData = props.listData || [];
  const sliderDots = [];
  const slides = listData.map(function (d, i) {
    const image = d.images && d.images.length > 0 ? d.images[0] : undefined;
    sliderDots.push(
      <SlideshowDot
        key={`${i}_${d.id}-dot`}
        backgroundColor={backgroundColor}
        image={image} />
    );
    return (
      <SlideComponent
        key={`${i}_${d.id}`}
        backgroundColor={backgroundColor}
        cellType="slideshow"
        contentConfig={contentConfig}
        {...props}
        id={d.id}
        data={d}
        inCell={true} />
    );
  });
  return (
    <div className="cont--kit__wrapper" style={props.containerStyle}>
      <div className={wrapperClassName} style={wrapperStyle}>
        <section className={className} id={props.id} style={style}>
          <div id={props.sliderId} className="slider slider--full__width slider--fit" {...props.sliderProps}>
            {slides}
          </div>
          {props.arrows}
          <div id={props.dotsId} className="slider--dots">
            {sliderDots}
          </div>
        </section>
      </div>
    </div>
  );
}

const Slideshow = withSlideshowInitialization(
  withSlideshowConfiguration(_Slideshow),
  _Slideshow,
  {
    autoplay: false,
    dots: true,
    items: 1,
    loop: true,
    nav: true,
    navText: false,
    margin: 40,
    smartSpeed: 1000
  }
);

function Slide(props) {
  const edition = InventoryHelper.edition(props.data) || {};
  let imageUrl;
  if (props.data.images && props.data.images.length > 0) {
    imageUrl = Image.url(
      props.data.images[0],
      undefined,
      1024,
      undefined,
      undefined,
      props.backgroundColor
    );
  }
  let imageData = {};
  if (props.data.seo) {
    imageData = {
      alt: props.data.seo.imageAlt,
      caption: props.data.seo.imageCaption,
      description: props.data.seo.imageDescription,
      title: props.data.seo.imageTitle
    };
  }
  let canOffer;
  let canPurchase;
  if (props.config && props.data.available && props.blockConfig.showPrice) {
    canOffer = props.config.canReceiveOffers;
    canPurchase = props.config.isStripeConnected;
  }
  let link = Url.getLink('', `art/${props.data.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
  let linkClickHandler;
  if (props.blockConfig.detailDisplay == 0) {
    link = '#';
    linkClickHandler = props.onModalOpen;
  }
  let soldClassName;
  switch (props.blockConfig.status) {
    case 2:
      soldClassName = 'artwork__inactive-sticker';
      break;
    case 4:
      soldClassName = 'artwork__sold-sticker';
      break;
  }
  return (
    <div className="slider__slide slide__cont" style={props.builder ? { pointerEvents: 'none' } : undefined}>
      <div className="slider__content--cont">
        <div className="slider__img">
          <a href={link} id={props.data.id} onClick={linkClickHandler}>
            <img src={imageUrl} {...imageData} />
          </a>
        </div>
        <div className="slider__details">
          <Container>
            <Row className="p-b-sm">
              <Column size="12">
                <a
                  href={link}
                  className={soldClassName}
                  id={props.data.id}
                  onClick={linkClickHandler}>
                  <Details
                    blockConfig={props.blockConfig}
                    data={props.data}
                    edition={edition}
                    isArtist={props.isArtist}
                    renderSticker={false}
                    renderPurchase={false} />
                  <h4 className="artwork__info__item artwork__info__item--location">
                    {props.data.location}
                  </h4>
                </a>
              </Column>
            </Row>
            <Row>
              {
                canPurchase &&
                <Column inline={true}>
                  <Clickable
                    className="btn btn--outl btn--sm btn--purchase"
                    onClick={() => props.onPurchase(props.data)}>
                    Purchase
                  </Clickable>
                </Column>
              }
              {
                canOffer &&
                <Column inline={true}>
                  <Clickable
                    className="btn btn--outl btn--sm btn--offer"
                    id="slider-offer-btn"
                    onClick={() => props.onOffer(props.data)}>
                    Make an Offer
                  </Clickable>
                </Column>
              }
              {
                props.data.contactUrl != undefined &&
                <Column inline={true}>
                  <a
                    href={props.data.contactUrl}
                    className="btn btn--outl btn--sm btn--inquire"
                    id="slider-inquire-btn">
                    Inquire
                  </a>
                </Column>
              }
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}

// #endregion SLIDESHOW

// #region WATERFALL

function Waterfall(props) {
  const animation = props.blockConfig.waterfall && props.blockConfig.waterfall.animation;
  let columnCount = props.blockConfig.columns || defaultColumnCount;
  let legacy = false;
  if (props.blockConfig.waterfall) {
    switch (props.screenSize) {
      case ScreenSize.Mobile:
        columnCount = props.blockConfig.waterfall.columnsPhone || 2;
        break;
      case ScreenSize.Tablet:
        columnCount = props.blockConfig.waterfall.columnsTablet || 3;
        break;
      case ScreenSize.Desktop:
      default:
        columnCount = props.blockConfig.waterfall.columns || columnCount;
        break;
    }
  } else {
    legacy = true;
  }
  let lineSpacing;
  const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign', configKey: 'waterfall' }, (propName, propValue, propUnit) => {
    switch (propName) {
      case 'animation':
      case 'cell':
      case 'columns':
      case 'columnSpacing':
      case 'display':
        return true;
      case 'lineSpacing':
        if (propUnit) {
          const value = propValue || 0;
          lineSpacing = `${value}${propUnit}`;
        }
        return true;
    }
  });
  const columnSize = Layout.columnSize(columnCount);
  const columns = Layout.columns(props.listData, columnCount);
  const content = columns.map(function (column, i) {
    return (
      <Column
        key={i}
        className={legacy ? undefined : 'col--custom'}
        size={columnSize}
        style={props.builder ? { pointerEvents: 'none' } : undefined}>
        {column.map((d, j) => (
          <WaterfallCell
            key={`${i}-${j}_${d.id}`}
            animation={animation}
            columnCount={columnCount}
            columnSpacing={props.blockConfig.waterfall && props.blockConfig.waterfall.columnSpacing}
            index={d.index}
            legacy={legacy}
            lineSpacing={lineSpacing}
            {...props}
            data={d}
            inCell={true} />
        ))}
      </Column>
    );
  });
  return (
    <ContentContainer className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
      <Spaced className="cont--kit__content" style={layoutStyles.style}>
        <Row className={legacy ? undefined : 'cont__row--custom'}>{content}</Row>
      </Spaced>
    </ContentContainer>
  );
}

function WaterfallCell(props) {
  if (!props.legacy) {
    return <InventoryListCell.InventoryCellContainer {...props} cellType="waterfall" contentConfig={Defaults.cellDesign(props.config, props.blockConfig, Kit.Context.Cell.Inventory.Waterfall)} />
  }
  let image = {};
  if (props.data.images && props.data.images.length > 0) {
    image = props.data.images[0];
  }
  const imageTuples = Image.sizes.map(function (d) {
    const url = Image.url(
      image,
      d,
      d,
      'c_fit',
      undefined,
      props.config && props.config.backgroundColor
    );
    return { size: d, url: url };
  });
  const lineSpacing = props.lineSpacing || '16px';
  return <Cell imageTuples={imageTuples} {...props} lineSpacing={lineSpacing} />;
}

// #endregion WATERFALL

export {
  InventoryListV3,

  // DEPRECATED
  InventoryListV2,
  InventoryListV1
}
